import { KommunikationRequestModel } from '../../modals/NachrichtSenden/KommunikationRequestModel';
import { NachrichtType } from '../models/Nachrichten/NachrichtModel';
import {
  conflictErrorMsg,
  conflictZbpKeypairNotFound,
  ErrorType
} from '../../shared/utils/Error/ErrorCode';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BehApiRoutes, behClient } from '../beh-api';
import { matchesCaseOrAllCasesQueries } from './caseQueryFilter';
import { useNotification } from '../../shared/notification/useNotification';
import { useTranslation } from 'react-i18next';

export function useSendMessage() {
  const { notifyUserFromRequest, notifyUser } = useNotification();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      payload,
      caseId
    }: {
      payload: KommunikationRequestModel;
      caseId: string;
    }) =>
      notifyUserFromRequest(
        () =>
          behClient.post(BehApiRoutes.caseSubmissions(caseId), payload, {
            headers: { 'Content-Type': 'application/vnd.fjd.beh.message+json' }
          }),
        {
          successMessage:
            payload.nachrichtType === NachrichtType.BESCHEID_POSTALISCH
              ? t('api.success.sendPostalischeNachricht')
              : t('api.success.sendMessage'),
          errorMessage: t('api.error.sendMessage'),
          errorIdHandler: {
            [ErrorType.BEHOERDENCLIENT_PROBLEMS_UPDATE_NOT_ALLOWED]: () => {
              notifyUser({
                intent: 'error',
                title: conflictErrorMsg
              });
            },
            [ErrorType.BEHOERDENCLIENT_PROBLEMS_ZBP_KEYPAIR_NOT_FOUND]: () => {
              notifyUser({
                intent: 'error',
                title: conflictZbpKeypairNotFound
              });
            }
          }
        }
      ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        predicate: matchesCaseOrAllCasesQueries(variables.caseId)
      });
    }
  });

  return { sendMessage: mutateAsync, loadingSend: isPending };
}
